module.exports = __webpack_public_path__ + "img/newbalance-logo.89ef96c2.svg";